// extracted by mini-css-extract-plugin
module.exports = {"store-layout":"store-layout--ubhog","zoom-wrapper":"zoom-wrapper--ubhog","zoom-wrapper__btn":"zoom-wrapper__btn--ubhog"};